import React, { useContext, useEffect, useState } from "react";
import { AnalisisCreditoContext } from "../AnalisisCreditoScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { ModalSolicitudCredito } from "../Modales/ModalSolicitudCredito";
import MdlSolicitudCreditoScreen from "../Modales/MdlSolicitudCreditoScreen";
import TimeLineTarget from "../TimeLine/TimeLineTarget";
import { AnalisisComentariosLine } from "../AnalisisComentariosLine";
import ComputerIcon from "@mui/icons-material/Computer";
import { ValidarCondcionesOperacion } from "./ValidarCondcionesOperacion";
import MdlValidacionPedido from "../Modales/MdlValidacionPedido";
import { CargarDocumentacionAsesor } from "./CargarDocumentacionAsesor";
import { AnalizarDocumentacion } from "./AnalizarDocumentacion";
import { OtorgamientoCreditoMhusa } from "./OtorgamientoCreditoMhusa";
import { AnalisarDocumentosOtorgamiento } from "./AnalisarDocumentosOtorgamiento";
import { AutorizarFacturacion } from "../JDF/AutorizarFacturacion";
import MhusaValidarEnganche from "./MhusaValidarEnganche";
import MhusaFacturarEquipo from "./MhusaFacturarEquipo";
import { MhusaCargarPAgareEquip } from "./MhusaCargarPAgareEquip";
import { MhusaFinalizacion } from "./MhusaFinalizacion";
import CommentIcon from "@mui/icons-material/Comment";
import TimelineIcon from "@mui/icons-material/Timeline";
import { ModalComentariosJDF } from "../JDF-Condicionado/Modales/ModalComentariosJDF";
import { CargarDocumentacionVendedor } from "../../Credito/CreditoCondicionado/CargarDcoumentacionVendedor";
import { ValidarCondicionesOperacionCondicionadaJDF } from "../JDF-Condicionado/ValidarCondicionesOperacionCondicionadaJDF";
import FacturarEquipoCondicionado from "../../Credito/CreditoCondicionado/FacturarEquipoCondicionado";
import { CargarPagareEquipCondicionado } from "../../Credito/CreditoCondicionado/CargarPagareEquipCondicionado";
import { CargarDocumentacionAprobadaCondicionado } from "../../Credito/CreditoCondicionado/CargarDocumentacionAprobadaCondicionado";
import { AnalizarDocumentacionAprobadaCondicionado } from "../../Credito/CreditoCondicionado/AnalizarDocumentacionAprobadaCondicionado";
import { FinalizaJDFCondicionado } from "../JDF-Condicionado/FinalizaJDFCondicionado";
import { FinalizarSolicitudCreditoCondicionado } from "../../Credito/CreditoCondicionado/FinalizarSolicitudCreditoCondicionado";
import { AnalizarDocumentacionVigencia } from "./AnalizarDocumentacionVigencia";
import { AnalisarDocumentosOtorgamientoVigencia } from "./AnalisarDocumentoOtirgamientoVigencia";
import { obtenerPasosHabilitados } from "../../../Helpers/TimelineHelper";


export const CreditoMhusaScreen = ({ data, estado, upload, direccion }) => {

  const { state } = useContext(AnalisisCreditoContext);
  const [openSolicitud, setOpenSolicitud] = useState(false);
  const [mostrarCondicionado, setMostrarCondicionado] = useState(false);
  const [mostrarComentarios, setMostrarComentarios] = useState(false);
  const [rechazoCondicionado, setRechazoCondicionado] = useState(false);
  const [valueCondicionado, setValueCondicionado] = useState(0);
  const [openSolicitudCondicionado, setOpenSolicitudCondicionado] =
    useState(false);
  const [comentarios, setComentario] = useState([]);
  const [dataCondicionado, setDataCondicionado] = useState({
    estado: {},
    detalle: [],
  });
  const [value, setValue] = useState(0);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    onActualizarComentarios();
    onCargarTimelineCondicionado();
  }, []);

  const onActualizarComentarios = () => {
    if (
      state.folio === undefined ||
      state.folio === null ||
      state.folio.length !== 13
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`AnalisisSolicitudCreditoComentarios/Listado?folio=${state.folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setComentario(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD", JSON.stringify(error), "error");
      });
  };

  const onCargarTimelineCondicionado = () => {
    if (
      estado.folio_condicionado === undefined ||
      estado.folio_condicionado === null ||
      estado.folio_condicionado.length !== 13
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SCCreditoCondicionado/CargarTimelineCondicionado?folio=${estado.folio_condicionado}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDataCondicionado({
          estado: result.estado,
          detalle: result.detalle,
        });

        setMostrarCondicionado(true);
        // if (data[8].habilitado === "False") {
        //   setMostrarCondicionado(true);

        // }
        // else {
        //   setMostrarCondicionado(false)
        // }
        if (result.detalle[2].estado === "Rechazado") {
          setRechazoCondicionado(true);
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD", JSON.stringify(error), "error");
      });
  };

  const onActualizarTimelineCondicionado = (folio) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`SCCreditoCondicionado/CargarTimelineCondicionado?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDataCondicionado({
          estado: result.estado,
          detalle: result.detalle,
        });

        if (result.detalle[2].estado === "Rechazado") {
          setRechazoCondicionado(true);
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD", JSON.stringify(error), "error");
      });
  };

  const onCreditoCondicionado = () => {
    if (rechazoCondicionado === true) {
      return;
    } else if (dataCondicionado.detalle.length !== 0) {
      setLoader({ ...loader, mostrar: true });
      const post = {
        folio: dataCondicionado.estado.folio,
        usuario: "",
      };
      request
        .post(`SCCreditoCondicionado/CancelarCondicionado`, post)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });

          setMostrarCondicionado(false);
          setDataCondicionado({ ...dataCondicionado, detalle: [] });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
        });
      // setMostrarCondicionado(!mostrarCondicionado);
    } else {
      setLoader({ ...loader, mostrar: true });
      const post = {
        folio: state.folio,
        cliente: state.cliente,
        usuario: "",
      };
      request
        .post(`SCCreditoCondicionado/CrearCondicionado`, post)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          // commentNotification(result.mdlSolicitud);
          setDataCondicionado({
            estado: result.estado,
            detalle: result.detalle,
          });
          setMostrarCondicionado(true);
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("ANALISIS DE CREDITO", JSON.stringify(error), "error");
        });
    }
  };

  // Función para manejar la apertura de precalificacion
  const handleOpenComentarios = () => {
    setMostrarComentarios(true);
  };

  // Función para manejar el cierre de MdlValidacionPedidoJDF
  const handleCloseComentarios = () => {
    setMostrarComentarios(false);
  };

  return (
    <PlantillaScreen
      titulo={"PROCESO DE SOLICITUD DE CREDITO DE LINEA POR OPERACION"}
      className={"analisis-sc-procesos"}
    >
      <LoaderScreen loader={loader} />
      {mostrarComentarios && (
        <ModalComentariosJDF
          setOpenSolicitud={handleCloseComentarios}
          titulo={"COMENTARIOS"}
          estado={estado}
          comentarios={comentarios}
        />
      )}
      <ModalSolicitudCredito
        open={openSolicitud}
        setOpenSolicitud={setOpenSolicitud}
        value={value}
        setValue={setValue}
        upload={upload}
        maxValue={Number(estado.pantallacompleta)}
        pasosHabilitados={obtenerPasosHabilitados(data)}
        screens={{
          screen0: (
            <MdlSolicitudCreditoScreen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen1: (
            <ValidarCondcionesOperacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              iddocumentopedido={25}
              idproceso={28}
            />
          ),
          screen2: (
            <MdlValidacionPedido
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              idproceso={29}
            />
          ),
          screen3: (
            <CargarDocumentacionAsesor
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              idproceso={30}
            />
          ),
          screen4: (
            <AnalizarDocumentacionVigencia
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              idproceso={31}
            />
          ),
          screen5: (
            <OtorgamientoCreditoMhusa
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen6: (
            <AnalisarDocumentosOtorgamientoVigencia
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen7: (
            <MhusaValidarEnganche
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen8: (
            <AutorizarFacturacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),

          screen9: (
            <MhusaFacturarEquipo
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen10: (
            <MhusaCargarPAgareEquip
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen11: (
            <MhusaFinalizacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
        }}
        titulos={{
          screen0: "SOLICITUD DE CREDITO",
          screen1: "VALIDAR CONDICIONES DE LA OPERACION",
          screen2: "VALIDAR PEDIDO",
          screen3: "CARGAR DOCUMENTACION",
          screen4: "ANALIZAR DOCUMENTACION",
          screen5: "ANALIZAR OTORGAMIENTO DE CREDITO",
          screen6: "CARGAR DOCUMENTACION",
          screen7: "VALIDAR ENGANCHE",
          screen8: "AUTORIZAR FACTURACION",
          screen9: "FACTURAR EQUIPO",
          screen10: "CAPTURAR INFORMACION EQUIP",
          screen11: "FINALIZAR SOLICITUD",
        }}
      />

      <div className="analisis-sc-procesos-timeline-header-container">
        <div className="analisis-sc-procesos-timeline-title-condicionado ">
          {state.cliente}
        </div>
        {/* {mostrarCondicionado === true && (        )} */}
        <div className="analisis-sc-procesos-timeline-buttons-container">
          {mostrarCondicionado === true && (
            <div
              className="solicitud-credito-detalle-boton-comentarios"
              onClick={() => handleOpenComentarios()}
            >
              <CommentIcon /> Comentarios
            </div>
          )}
          {estado.habilitarcondicionado === true && direccion !== "V" && (
            <div
              className={
                mostrarCondicionado === false
                  ? "solicitud-credito-detalle-boton-timeline-condicionado"
                  : "solicitud-credito-detalle-boton-timeline-condicionado-rechazado"
              }
              onClick={() => onCreditoCondicionado()}
            >
              <TimelineIcon />{" "}
              {mostrarCondicionado === false
                ? "Crédito condicionado"
                : rechazoCondicionado === true
                  ? "Condicionado rechazado" : "Cancelar Condicionado"}
            </div>
          )}
        </div>

      </div>

      <div className="analisis-sc-procesos-timeline scroll">
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Genero Solicitud"}
          subtitle={"Vendedor"}
          footer={{
            tiempoestimado: data[0].estado,
            leyenda: data[0].creado,
            duracion: data[0].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[0].control}
          active={1 === Number(estado.pantallacompleta)}
          value={0}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Validar Condiciones Operación"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[1].estado,
            leyenda: data[1].creado,
            duracion: data[1].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[1].control}
          active={2 === Number(estado.pantallacompleta)}
          value={1}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Validar Pedido"}
          subtitle={"Gerente Sucursal"}
          footer={{
            tiempoestimado: data[2].estado,
            leyenda: data[2].creado,
            duracion: data[2].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[2].control}
          active={3 === Number(estado.pantallacompleta)}
          value={2}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Cargar Documentación"}
          subtitle={"Asesor de Ventas"}
          footer={{
            tiempoestimado: data[3].estado,
            leyenda: data[3].creado,
            duracion: data[3].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[3].control}
          active={4 === Number(estado.pantallacompleta)}
          value={3}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Analizar Documentación"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[4].estado,
            leyenda: data[4].creado,
            duracion: data[4].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[4].control}
          active={5 === Number(estado.pantallacompleta)}
          value={4}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Analizar Otorgamiento de Crédito"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[5].estado,
            leyenda: data[5].creado,
            duracion: data[5].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[5].control}
          active={6 === Number(estado.pantallacompleta)}
          value={5}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Cargar Documentación"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[6].estado,
            leyenda: data[6].creado,
            duracion: data[6].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[6].control}
          active={7 === Number(estado.pantallacompleta)}
          value={6}
          setValue={setValue}
        />

        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Validar Enganche"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[7].estado,
            leyenda: data[7].creado,
            duracion: data[7].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[7].control}
          active={8 === Number(estado.pantallacompleta)}
          value={7}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Autorizar Facturación"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[8].estado,
            leyenda: data[8].creado,
            duracion: data[8].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[8].control}
          active={9 === Number(estado.pantallacompleta)}
          value={8}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Facturar Equipo"}
          subtitle={"Cajera/Asistente ventas"}
          footer={{
            tiempoestimado: data[9].estado,
            leyenda: data[9].creado,
            duracion: data[9].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[9].control}
          active={10 === Number(estado.pantallacompleta)}
          value={9}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Cargar Pagare EQUIP"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[10].estado,
            leyenda: data[10].creado,
            duracion: data[10].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[10].control}
          active={11 === Number(estado.pantallacompleta)}
          value={10}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Finalizar Solicitud"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[11].estado,
            leyenda: data[11].creado,
            duracion: data[11].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[11].control}
          active={12 === Number(estado.pantallacompleta)}
          value={11}
          setValue={setValue}
          endtarget={true}
        />
      </div>


      {mostrarCondicionado === false && (
        <AnalisisComentariosLine
          tiempotranscurrido={estado.tiempotranscurrido}
          tiempoestimado={estado.tiempoestimado}
          comentarios={comentarios}
        />
      )}

      <ModalSolicitudCredito
        open={openSolicitudCondicionado}
        setOpenSolicitud={setOpenSolicitudCondicionado}
        upload={upload}
        value={valueCondicionado}
        setValue={setValueCondicionado}
        maxValue={
          Number(dataCondicionado.estado.pantallacompleta) > 8
            ? 9
            : Number(dataCondicionado.estado.pantallacompleta)
        }
        pasosHabilitados={obtenerPasosHabilitados(dataCondicionado.detalle)}
        screens={{
          screen0: (
            <MdlSolicitudCreditoScreen
              folio={
                estado.folio_condicionado === null
                  ? dataCondicionado.estado.folio
                  : estado.folio_condicionado
              }
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen1: (
            <CargarDocumentacionVendedor
              folio={
                estado.folio_condicionado === null
                  ? dataCondicionado.estado.folio
                  : estado.folio_condicionado
              }
              setLoader={setLoader}
              loader={loader}
              idproceso={100}
              upload={onActualizarTimelineCondicionado}
            />
          ),
          screen2: (
            <ValidarCondicionesOperacionCondicionadaJDF
              folio={
                estado.folio_condicionado === null
                  ? dataCondicionado.estado.folio
                  : estado.folio_condicionado
              }
              setLoader={setLoader}
              loader={loader}
              upload={upload}
            />
          ),
          screen3: (
            <FacturarEquipoCondicionado
              folio={
                estado.folio_condicionado === null
                  ? dataCondicionado.estado.folio
                  : estado.folio_condicionado
              }
              setLoader={setLoader}
              loader={loader}
              upload={onActualizarTimelineCondicionado}
            />
          ),
          screen4: (
            <CargarPagareEquipCondicionado
              folio={
                estado.folio_condicionado === null
                  ? dataCondicionado.estado.folio
                  : estado.folio_condicionado
              }
              setLoader={setLoader}
              loader={loader}
              upload={onActualizarTimelineCondicionado}
            />
          ),
          screen5: (
            <CargarDocumentacionAprobadaCondicionado
              folio={
                estado.folio_condicionado === null
                  ? dataCondicionado.estado.folio
                  : estado.folio_condicionado
              }
              setLoader={setLoader}
              loader={loader}
              idproceso={30}
              upload={onActualizarTimelineCondicionado}
            />
          ),
          screen6: (
            <AnalizarDocumentacionAprobadaCondicionado
              folio={
                estado.folio_condicionado === null
                  ? dataCondicionado.estado.folio
                  : estado.folio_condicionado
              }
              setLoader={setLoader}
              loader={loader}
              idproceso={30}
              upload={onActualizarTimelineCondicionado}
            />
          ),
          screen7: (
            <FinalizarSolicitudCreditoCondicionado
              folio={
                estado.folio_condicionado === null
                  ? dataCondicionado.estado.folio
                  : estado.folio_condicionado
              }
              setLoader={setLoader}
              loader={onActualizarTimelineCondicionado}
              upload={upload}
            />
          ),
        }}
        titulos={{
          screen1: "OPERACION CONDICIONADA",
          screen2: "VALIDAR CONDICIONES",
          screen3: "FACTURAR EQUIPO",
          screen4: "CARGAR PAGARE EQUIP",
          screen5: "CARGAR DOCUMENTACION",
          screen6: "ANALIZAR DOCUMENTACION",
          screen7: "FINALIZAR SOLICITUD",
        }}
      />

      {mostrarCondicionado === true && (
        <div className="analisis-credito-tiempos-condicionado-container">
          <div className="analisis-credito-comentarios-header-condicionado">
            <div className="analisis-credito-comentarios-header-comentarios-condicionado">
              {/* <CommentIcon /> */}
              TIMELINE CONDICIONADO
            </div>
          </div>

          <div className="analisis-sc-procesos-timeline-condicionado scroll">
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Operacion condicionada"}
              subtitle={"Gerente de linea"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[1].estado,
                leyenda: dataCondicionado.detalle[1].creado,
                duracion: dataCondicionado.detalle[1].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[1].control}
              active={2 === Number(dataCondicionado.estado.pantallacompleta)}
              value={1}
              setValue={setValueCondicionado}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Validar condiciones"}
              subtitle={"Gerente de finanzas"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[2].estado,
                leyenda: dataCondicionado.detalle[2].creado,
                duracion: dataCondicionado.detalle[2].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[2].control}
              active={3 === Number(dataCondicionado.estado.pantallacompleta)}
              value={2}
              setValue={setValueCondicionado}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Facturar equipo"}
              subtitle={"Auxiliar de ventas"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[3].estado,
                leyenda: dataCondicionado.detalle[3].creado,
                duracion: dataCondicionado.detalle[3].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[3].control}
              active={4 === Number(dataCondicionado.estado.pantallacompleta)}
              value={3}
              setValue={setValueCondicionado}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Cargar pagare Equip"}
              subtitle={"Cajera"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[4].estado,
                leyenda: dataCondicionado.detalle[4].creado,
                duracion: dataCondicionado.detalle[4].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[4].control}
              active={5 === Number(dataCondicionado.estado.pantallacompleta)}
              value={4}
              setValue={setValueCondicionado}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Cargar documentación"}
              subtitle={"Gerente de linea"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[5].estado,
                leyenda: dataCondicionado.detalle[5].creado,
                duracion: dataCondicionado.detalle[5].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[5].control}
              active={6 === Number(dataCondicionado.estado.pantallacompleta)}
              value={5}
              setValue={setValueCondicionado}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Analizar documentación"}
              subtitle={"Gerente de finanzas"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[6].estado,
                leyenda: dataCondicionado.detalle[6].creado,
                duracion: dataCondicionado.detalle[6].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[6].control}
              active={7 === Number(dataCondicionado.estado.pantallacompleta)}
              value={6}
              setValue={setValueCondicionado}
            // seleccionado={seleccionado}
            // setSeleccionado={setSeleccionado}
            />
            <TimeLineTarget
              icon={<ComputerIcon />}
              title={"Finalizar solicitud"}
              subtitle={"Gerente de finanzas"}
              footer={{
                tiempoestimado: dataCondicionado.detalle[7].estado,
                leyenda: dataCondicionado.detalle[7].creado,
                duracion: dataCondicionado.detalle[7].tiempoestimado,
                comentarios: "",
              }}
              openModal={setOpenSolicitudCondicionado}
              color={dataCondicionado.detalle[7].control}
              active={8 === Number(dataCondicionado.estado.pantallacompleta)}
              value={7}
              setValue={setValueCondicionado}
              endtarget={true}
            // seleccionado={0}
            // setSeleccionado={setSeleccionado}
            />
          </div>
        </div>
      )}
    </PlantillaScreen>
  );
};

